import { useMutation } from "@tanstack/react-query";
import {
  BulkOperation,
  BulkOperationsPayload,
  BulkOperationsResponse,
  performBulkOperations
} from "PFCore/services/bulk_operations";

export const useBulkOperationsCreate = <O extends BulkOperation, T>() =>
  useMutation<BulkOperationsResponse, Error, BulkOperationsPayload<O, T>>({
    mutationFn: performBulkOperations
  });
